import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';
import { useNavigate } from 'react-router-dom';

import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';

import { ModalContextType } from '../../../contexts/modalContext';
import { configs } from '../../../constants/configs/configs';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    enrollmentEndDate: string;
}

export default function DisenrollIneligibleGroupModal({ closeModal, enrollmentEndDate }: IModalProps) {
    const navigate = useNavigate();
    const { routes } = configs;
    const { exchangeName } = useAppSelector(environmentSelector);

    function onClose(e) {
        e?.preventDefault();
        closeModal('disenrollIneligibleGroupModal');
        navigate(routes.INDPORTAL);
    }

    return (
        <Modal id="disenrollIneligibleGroupModal">
            <Modal.Header id="disenrollIneligibleGroupModalHeader" titleId="indportal.disenrollIneligibleGroup.involuntarydisenrollmentrequestsubmitted" onHide={onClose} />
            <Modal.Body id="disenrollIneligibleGroupModalBody">
                <p>
                    <FormattedMessage id="customGrouping.ineligibledisenrollgroup" values={{ exchangeName, enrollmentEndDate }}/>
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="disenrollIneligibleGroupModalGoToDashboardButton" 
                    onClickHandler={onClose} 
                    variant="primary" 
                    labelId="button.go_to_dashboard" 
                />
            </Modal.Controls>
        </Modal>
    );
}
